import { Card, CardContent } from "@/components/ui/card";

interface ErrorMessageProps {
  message: string;
  details: string;
  stack?: string;
}

export function ErrorComponent({ message, details, stack }: ErrorMessageProps) {
  return (
    <main className="pt-16 px-4 container mx-auto max-w-[1280px]">
      <Card>
        <CardContent className="space-y-6 p-8 text-center">
          <h1 className="text-4xl font-bold">{message}</h1>
          <p className="text-lg text-muted-foreground">{details}</p>

          {stack && (
            <pre className="w-full p-4 overflow-x-auto rounded-md bg-muted text-sm text-left">
              <code>{stack}</code>
            </pre>
          )}

          <div className="pt-4">
            <a
              href="http://dayschedule.com"
              className="text-blue-600 hover:underline text-lg font-medium"
            >
              Go to Home Page
            </a>
          </div>
        </CardContent>
      </Card>
    </main>
  );
}
